import gql from 'graphql-tag';

import { MasterData } from '../models';

export class WarehouseConditionMasterData {
  preorderWarehouseTypes: PreorderWarehouseTypes[];
}

export class PreorderWarehouseTypes extends MasterData {
  active: boolean;
}

export const warehouseMasterQuery = gql`
  query {
    warehouses(sort: { orderBy: WMS_CODE, orderDirection: ASC }) {
      code
      nameEn
      nameTh
      contactName
      contactNumber
      address
      fullNameTh
      fullNameEn
      wmsCode
      billTo {
        code
        nameEn
        nameTh
        contactName
        contactNumber
        address
      }
    }
  }
`;

export const warehouseQuery = gql`
  query {
    offices {
      id
      code
      nameTh
    }
    warehouses(sort: { orderBy: WMS_CODE, orderDirection: ASC }) {
      id
      code
      nameTh
      wmsCode
      defaultFirstLot
      defaultStorageType
      allStorageTypes
      splitStorageTypes
    }
  }
`;

export const warehouseConditionMasterQuery = gql`
  query {
    preorderWarehouseTypes {
      nameEn
      code
      active
    }
  }
`;

export const activeWarehouseQuery = gql`
  query {
    warehouses(status: "ACTIVE", sort: { orderBy: WMS_CODE, orderDirection: ASC }) {
      id
      code
      nameTh
      wmsCode
      defaultFirstLot
      defaultStorageType
      allStorageTypes
      splitStorageTypes
    }
  }
`;
